import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Relatório Analítico',
    path: 'relatorio-analitico',
    name: 'recebimentoitemanaliticograute',
    component: () => import('@/views/dashboard/recebimento-item/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.Relatorio],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Recebimento Consolidado',
    path: 'recebimento-consolidado',
    name: 'recebimentoconsolidadograute',
    component: () => import('@/views/dashboard/recebimento/Index.vue'),
    meta: { utlTipoFornecimentoId: 4, permissions: [EPermissoes.Relatorio], escopoObra: 'obra' },
    goesToMenu: true
  },

  {
    description: 'Ensaio Consolidado',
    path: 'ensaio-consolidado',
    name: 'ensaioconsolidadoanaliticograute',
    component: () => import('@/views/dashboard/ensaio-consolidado/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.Relatorio],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
];



